import { ONBOARDING_MODAL_PADDING } from "../components/OnboardingModal/styles";

export const ONBOARDING_MIN_CONTENT_WRAPPER_WIDTH = 610;
export const ONBOARDING_LEFT_PART_WIDTH = 348;
export const ONBOARDING_CONTENT_SIDE_PADDING = 32;
export const ONBOARDING_CONTENT_TOP_PADDING = 56;
export const ONBOARDING_FOOTER_HEIGHT = 53;
const ONBOARDING_CONTENT_INNER_SPACE = ONBOARDING_CONTENT_SIDE_PADDING * 2;
const ONBOARDING_CONTENT_OUTSIDE_SPACE =
    ONBOARDING_MODAL_PADDING + ONBOARDING_LEFT_PART_WIDTH + ONBOARDING_CONTENT_INNER_SPACE;
